// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lGU_","title":"Header_title__189aW","left":"Header_left__3hCvv","clinicName":"Header_clinicName__1hfxT"};